import { useParams } from 'react-router-dom';
import { usePeople } from '../api/use-people.js';
import { PracticeDetail } from '../components/practice-detail.js';
import { PracticesPage } from '../components/practices-page.js';
import { WaitNote } from '../components/wait-note.js';

/**
 * A child's Practices for a parent (decision 6, ruled 1 November): from the
 * child's page, the same summary and list, with Start a practice for that child.
 * A parent reads a practice; the athlete is the one who changes it.
 */
export function FamilyPracticesRoute() {
  const { clientId = '', practiceId } = useParams();
  const { state } = usePeople();
  if (state.status !== 'ready') return <WaitNote className="empty">Loading…</WaitNote>;
  const child = state.people.find((person) => person.client_id === clientId && !person.is_account_holder);
  if (!child) return <p className="empty">That is not there any more.</p>;
  const page = `/account/people/${clientId}/practices`;
  if (practiceId) {
    return (
      <PracticeDetail
        practiceId={practiceId}
        whose={`${child.first_name} · `}
        back={{ to: page, label: `Back to ${child.first_name}'s practices` }}
        editable={false}
      />
    );
  }
  return (
    <PracticesPage
      athleteClientId={clientId}
      title={`${child.first_name} · Practices`}
      back={{ to: `/account/people/${clientId}`, label: `Back to ${child.first_name}` }}
      start={`/tools/recul?for=${clientId}`}
      practiceLink={(id) => `${page}/${id}`}
    />
  );
}
